import Cookies from 'js-cookie';
import md5 from 'md5';

const TokenKey = 'cg_token';
const subTokenKey = 'loginToken';
let subDomin = '.' + document.domain;
if (document.domain.includes('gameinfo')) {
  subDomin = '.gameinfo.xyz';
} else if (document.domain.includes('gameexp')) {
  subDomin = '.gameexp.com';
}
console.log('subDomin', subDomin);
export function getToken() {
  return window.localStorage.getItem(TokenKey);
}


export function setToken(token) {
  try {
    Cookies.set(subTokenKey, token, { domain: subDomin });
  } catch (e) { }
  return window.localStorage.getItem(TokenKey);

}

//匿名登录 设置匿名openId
export function setAnonymousToken() {
  let token = 'anonymous_' + new Date().getTime();
  return Cookies.set(subTokenKey, token, { domain: subDomin });
}
//匿名登录 设置匿名openId
export function setAnonymousOpenId() {
  let openId = 'anonymous_' + new Date().getTime();
  return Cookies.set('openid', openId, { domain: subDomin });
}



export function removeToken() {
  try {
    Cookies.remove(subTokenKey, { domain: subDomin });
  } catch (e) {

  }
  return Cookies.remove(TokenKey);
}

//国内先游问卷系统
export function setOpenId(openId) {
  try {
    Cookies.set('ParentOpenid', openId, { expires: 30 * 6 });
  } catch (e) { }
  return Cookies.set('openid', openId, { domain: subDomin });
}


//国内先游问卷系统
export function getOpenId() {
  return Cookies.get('openid', { domain: subDomin });
}

export function removeOpenId() {
  try {
    Cookies.remove('ParentOpenid');
  } catch (e) { }
  return Cookies.remove('openid', { domain: subDomin });
}

//国内先游问卷系统
export function setTestId(testId) {
  // 注释cookies：问卷系统已经不会使用了
  // try{
  //   Cookies.set('ParentTestId', testId)
  // }catch (e) {}
  // return Cookies.set('testId', testId, { domain: subDomin})
}
//国内先游问卷系统
export function removeTestId() {
  // 注释cookies：问卷系统已经不会使用了
  // try{
  //   Cookies.remove('ParentTestId')
  // }catch (e) {}
  // return Cookies.remove('testId', { domain: subDomin })
}

//国内先游问卷系统
export function setGameId(gameId) {
  // 注释cookies：问卷系统已经不会使用了
  // try{
  //   Cookies.set('ParentGameId', gameId)
  // }catch (e) {}
  // return Cookies.set('gameId', gameId, { domain: subDomin})
}
//国内先游问卷系统
export function removeGameId() {
  // 注释cookies：问卷系统已经不会使用了
  // try{
  //   Cookies.remove('ParentGameId')
  // }catch (e) {}
  // return Cookies.remove('gameId', { domain: subDomin })
}



// 第三方登录是需要使用
export function setRedirect(redirect) {
  return Cookies.set('redirect', redirect);
}
// 第三方登录是需要使用
export function getRedirect() {
  return Cookies.get('redirect');
}

// 第三方登录是需要使用
export function removeRedirect() {
  return Cookies.remove('redirect');
}


//国内先游问卷系统
export function getParentOpenId() {
  return Cookies.get('ParentOpenid');
}
export function getParentTestId() {
  return Cookies.get('ParentTestId');
}
export function getParentGameId() {
  return Cookies.get('ParentGameId');
}

// // 存储渠道
// export function setChannel(channel) {
//   if(channel){
//     return Cookies.set('channel', channel);
//   }else {
//     return Cookies.set('channel', 'expself');
//   }
// }
// 获取渠道
export function getChannel() {
  return Cookies.get('channel');
}
// 存储 channel_gameId
export function setChannelGameId(gameId) {
  return Cookies.set('channel_gameId', gameId);
}
// 获取 channel_gameId
export function getChannelGameId() {
  return Cookies.get('channel_gameId');
}



//beta 测试首页版本记录
export function setHomeAbTestVersion(path) {
  return Cookies.set('HomeAbTestVersion-2020-12-01', path, { expires: 30 });
}
//beta 测试首页版本记录
export function getHomeAbTestVersion(path) {
  return Cookies.get('HomeAbTestVersion-2020-12-01', path, { expires: 30 });
}

//跳转到问卷系统
export function navigateToQuestion() {

}